export function getColor(colorObj, color) {
    switch (color) {
        case 'dashboard':
            return colorObj.color ? colorObj.color : colorObj.dashboard;
        case 'leads':
            return colorObj.color ? colorshift(colorObj.color, -20, -10, 10) : colorObj.leads;
        case 'vehicles':
            return colorObj.color ? colorshift(colorObj.color, 20, -10, 10) : colorObj.fahrzeuge;
        case 'client':
            return colorObj.color ? colorshift(colorObj.color, -20, -20, 20) : colorObj.kunden;
        case 'qr':
            return colorObj.color ? colorshift(colorObj.color, 20, -20, 20) : colorObj.qr;
        case 'bdc':
            return colorObj.color ? colorshift(colorObj.color, 0, -30, 30) : colorObj.bdc;
        default:
            return colorObj.color ? colorshift(colorObj.color, -20, -10, 10) : colorObj.other;
    }
}

export function hexToHSL(H) {
    // Convert hex to RGB first
    let r: any = 0;
    let g: any = 0;
    let b: any = 0;
    if (H.length == 4) {
        r = '0x' + H[1] + H[1];
        g = '0x' + H[2] + H[2];
        b = '0x' + H[3] + H[3];
    } else if (H.length == 7) {
        r = '0x' + H[1] + H[2];
        g = '0x' + H[3] + H[4];
        b = '0x' + H[5] + H[6];
    }
    // Then to HSL
    r /= 255;
    g /= 255;
    b /= 255;
    const cmin = Math.min(r, g, b);
    const cmax = Math.max(r, g, b);
    const delta = cmax - cmin;
    let h = 0;
    let s = 0;
    let l = 0;

    if (delta == 0) h = 0;
    else if (cmax == r) h = ((g - b) / delta) % 6;
    else if (cmax == g) h = (b - r) / delta + 2;
    else h = (r - g) / delta + 4;

    h = Math.round(h * 60);

    if (h < 0) h += 360;

    l = (cmax + cmin) / 2;
    s = delta == 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);

    return { h: h, s: s, l: l };
}

export function hslToHex(hsl) {
    const h = hsl.h;
    let s = hsl.s;
    let l = hsl.l;

    s /= 100;
    l /= 100;

    const c = (1 - Math.abs(2 * l - 1)) * s;
    const x = c * (1 - Math.abs(((h / 60) % 2) - 1));
    const m = l - c / 2;
    let r: any = 0;
    let g: any = 0;
    let b: any = 0;

    if (0 <= h && h < 60) {
        r = c;
        g = x;
        b = 0;
    } else if (60 <= h && h < 120) {
        r = x;
        g = c;
        b = 0;
    } else if (120 <= h && h < 180) {
        r = 0;
        g = c;
        b = x;
    } else if (180 <= h && h < 240) {
        r = 0;
        g = x;
        b = c;
    } else if (240 <= h && h < 300) {
        r = x;
        g = 0;
        b = c;
    } else if (300 <= h && h < 360) {
        r = c;
        g = 0;
        b = x;
    }
    // Having obtained RGB, convert channels to hex
    r = Math.round((r + m) * 255).toString(16);
    g = Math.round((g + m) * 255).toString(16);
    b = Math.round((b + m) * 255).toString(16);

    // Prepend 0s, if necessary
    if (r.length == 1) r = '0' + r;
    if (g.length == 1) g = '0' + g;
    if (b.length == 1) b = '0' + b;

    return '#' + r + g + b;
}

export function colorshift(color, degree, saturation, light) {
    const hsl = hexToHSL(color);
    hsl.h += degree;
    if (hsl.h > 360) hsl.h -= 360;
    if (hsl.h < 0) hsl.h += 360;
    hsl.s += saturation;
    if (hsl.s > 60) hsl.s = 60;
    if (hsl.s < 0) hsl.s = 0;
    hsl.l += light;
    if (hsl.l > 80) hsl.l = 80;
    if (hsl.l < 0) hsl.l = 0;
    return hslToHex(hsl);
}
